<template>
	<div class="mb-20">
		<div class="disp-flex mb-10">
			<div class="user-activity">
				<div style="width: 60px">
					<div class="user-block">
						<avatar :username="loggedInUserInfo && loggedInUserInfo.username ? loggedInUserInfo.username : ''"></avatar>
					</div>
				</div>
			</div>
			<div style="width: 100%" class="textarea-wrapper">
				<el-input v-model="noteMessage" :placeholder="$t('whatLikeToSay')" type="textarea" :rows="2" @focus="handleFocus" @blur="handleBlur" />
			</div>
		</div>
		<div v-if="hasFocus" class="disp-flex">
			<div style="width: 60px"></div>
			<div>
				<LoadingButton size="mini" type="primary" :execute="onSave">{{ $t('save') }}</LoadingButton>
				<el-button size="mini" type="info" @click="onCancel">{{ $t('cancel') }}</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { EventBus } from '@/eventBus';
import LoadingButton from '@/components/_Buttons/LoadingButton.vue';
import { INSERT_NOTE, GET_PERSON_BY_EXTERNAL_ID, INSERT_INVOICE_NOTE } from '@/gql';
import getUserInfo from '@/cognito/getUserInfo';
import Avatar from 'vue-avatar';
import async from 'async-es';
import { mapGetters } from 'vuex';
import Logging from '@/logging';

export default {
	components: {
		Avatar,
		LoadingButton
	},
	props: {
		type: {
			type: String,
			default: () => ''
		},
		legalEntityProp: {
			type: String,
			required: true
		},
		recipientProp: {
			type: String,
			required: true
		},
		single: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			avatarPrefix: '?imageView2/1/w/80/h/80',
			isFocused: false,
			noteMessage: '',
			loggedInUserInfo: {}
		};
	},
	computed: {
		hasFocus() {
			return this.isFocused;
		},
		...mapGetters(['env', 'selectedParticipantStore', 'selectedInvoices'])
	},
	created() {
		getUserInfo()
			.then(({ data }) => {
				this.loggedInUserInfo = data;
			})
			.catch(e => {
				Logging.error(e);
			});
	},
	methods: {
		handleFocus() {
			this.isFocused = true;
		},
		handleBlur() {
			if (this.noteMessage === '') {
				this.isFocused = false;
			} else {
				// do nothing
			}
		},
		onSave() {
			Logging.log('NewNote.onSave');
			this.noteMessage = this.noteMessage.replace(/(\r\n|\n|\r)/gm, '');
			let _this = this;
			let promise = this.$apollo
				.query({
					query: GET_PERSON_BY_EXTERNAL_ID,
					variables: {
						externalId: this.loggedInUserInfo.sub
					}
				})
				.then(({ data }) => {
					if (this.type === 'invoice') {
						let _this = this;
						// ====================
						// step 1: insert note
						// ====================

						let payload = {
							note: this.noteMessage,
							participant: this.selectedParticipantStore,
							legal_entity: this.legalEntityProp,
							recipient: this.recipientProp,
							created_by: data.risolto_person[0].reference
						};

						Logging.log('payload: ', payload);
						this.$apollo
							.mutate({
								mutation: INSERT_NOTE,
								variables: payload
							})
							.then(({ data }) => {
								Logging.log('RESULT VAN INSERT_NOTE: ', data.result.returning[0].reference);
								if (data.result.returning[0].reference) {
									// ============================================================
									// step 2: for each selected invoice, insert into note_invoice
									// ============================================================

									async.each(
										this.selectedInvoices,
										(si, callback) => {
											payload = {
												note: data.result.returning[0].reference,
												invoice: si.reference,
												participant: si.participant,
												legalEntity: si.legal_entity
											};

											_this.$apollo
												.mutate({
													mutation: INSERT_INVOICE_NOTE,
													variables: payload
												})
												.then(result => {
													Logging.log('An Invoice Note was stored in DB.');
													callback();
												})
												.catch(e => {
													Logging.error('There was an error when storing Invoice Note in DB.');
													callback(e);
												});
										},
										err => {
											if (err) {
												_this.$notify({
													title: _this.$t('somethingWentWrong'),
													message: _this.$t('somethingWentWrong'),
													type: 'error'
												});
											} else {
												// ============================================================
												// step 3: all invoice notes are made => confirm the action
												// ============================================================
												this.$notify({
													title: 'Notities aangemaakt',
													type: 'success'
												});
												EventBus.$emit('refetchActionsNotes');
											}
										}
									);
								}
							});
					} else if (this.type === 'recipient') {
						let vars = {
							note: this.noteMessage,
							participant: this.selectedParticipantStore,
							legal_entity: this.legalEntityProp,
							recipient: this.recipientProp,
							created_by: data.risolto_person[0].reference
						};

						Logging.log('create note vars: ', vars);
						this.$apollo
							.mutate({
								mutation: INSERT_NOTE,
								variables: vars
							})
							.then(result => {
								this.$notify({
									title: this.$t('noteCreated'),
									type: 'success'
								});
								EventBus.$emit('refetchActionsNotes');
								this.isFocused = false;
								this.noteMessage = '';
							});
					} else {
						Logging.log('other comment type');
					}
				})
				.catch(e => {
					Logging.error(e);
				});
			return promise;
		},
		onCancel() {
			this.noteMessage = '';
			this.isFocused = false;
		}
	}
};
</script>

<style lang="scss" scoped>
.user-activity {
	.user-block {
		.username,
		.description {
			display: block;
			margin-left: 50px;
			padding: 2px 0;
		}

		.username {
			font-size: 16px;
			color: #000;
		}

		:after {
			clear: both;
		}

		.img-circle {
			border-radius: 50%;
			width: 40px;
			height: 40px;
			float: left;
		}

		span {
			font-weight: 500;
			font-size: 12px;
		}
	}

	.post {
		font-size: 14px;
		border-bottom: 1px solid #d2d6de;
		margin-bottom: 15px;
		padding-bottom: 15px;
		color: #666;

		.image {
			width: 100%;
			height: 100%;
		}

		.user-images {
			padding-top: 20px;
		}
	}

	.list-inline {
		padding-left: 0;
		margin-left: -5px;
		list-style: none;

		li {
			display: inline-block;
			padding-right: 5px;
			padding-left: 5px;
			font-size: 13px;
		}

		.link-black {
			&:hover,
			&:focus {
				color: #999;
			}
		}
	}
}

.box-center {
	margin: 0 auto;
	display: table;
}

.text-muted {
	color: #777;
}</style
>script
